import moment from "moment";

export const buildWeekDaysFromEnd = (endOfWeekDate) => {
  const daysBeforeEnd = Array.from({ length: 6 }).map(
    (_, i) => moment(endOfWeekDate).subtract(i + 1, "day")
  );
  return [endOfWeekDate, ...daysBeforeEnd];
};